module.exports = __webpack_public_path__ + "img/HTIT-WB32LA.30757c14.jpg";